import { Button, Row } from "@intech/web-ui";
import styled from "styled-components";
import { device } from "../../../../../device";

export const SmallButton = styled(Button)`
  width: auto;
  white-space: nowrap;
`;

export const WrapRow = styled(Row)`
  width: 100%;
  justify-content: end;
  @media ${device.tablet}{
    flex-wrap: wrap;
  }
  @media not ${device.tablet}{
    flex-direction: column;
  }
`;

export const BloatDiv = styled.div`
  @media ${device.tablet}{
    flex: 0 0 30%;
    max-width: 30%;
  }
  @media not ${device.tablet}{
    flex: 0 0 100%;
    max-width: 100%;
  }
`;

export const Title = styled.h4`
  text-align: center;
  margin-bottom: 40px;
`;